package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter5.getRecapVerbiParticipiQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_verbi_e_participi_1
import gero.composeapp.generated.resources.exp_content_verbi_e_participi_2
import gero.composeapp.generated.resources.exp_content_verbi_e_participi_3
import gero.composeapp.generated.resources.exp_title_verbi_e_participi

fun getVerbiEParticipiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_verbi_e_participi,
            content = Res.string.exp_content_verbi_e_participi_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_e_participi,
            content = Res.string.exp_content_verbi_e_participi_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_e_participi,
            content = Res.string.exp_content_verbi_e_participi_3,
            face = Faces.Happy,
            character = Characters.Zeta,
        )
    )
}

fun getVerbiEParticipiQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return getRecapVerbiParticipiQuizContent(words, languageCode)
}
